import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9428aea8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "l-form-header" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "l-option" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#c0bebe","text-align":"center","width":"90%","padding":"5px"} }, "☝ 拖拽控件到表格内部", -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("复制")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "table-column-action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_FormDesignRender = _resolveComponent("FormDesignRender")!
  const _component_vue_draggable_next = _resolveComponent("vue-draggable-next")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mode === 'DESIGN')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_vue_draggable_next, {
            class: "l-drag-from",
            list: _ctx._columns,
            group: "form",
            options: { animation: 300, chosenClass: 'choose', sort: true },
            onStart: _cache[0] || (_cache[0] = ($event: any) => {
                    _ctx.drag = true;
                    _ctx.selectFormItem = null;
                }),
            onEnd: _cache[1] || (_cache[1] = ($event: any) => (_ctx.drag = false))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._columns, (cp, id) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: id,
                  class: "l-form-item",
                  style: _normalizeStyle(_ctx.getSelectedClass(cp)),
                  onClick: _withModifiers(($event: any) => (_ctx.selectItem(cp)), ["stop"])
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("p", null, [
                      (cp.props.required)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
                        : _createCommentVNode("", true),
                      _createTextVNode(_toDisplayString(cp.title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_icon, {
                        size: "1em",
                        onClick: ($event: any) => (_ctx.delItem(id))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Close)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _createVNode(_component_FormDesignRender, { config: cp }, null, 8, ["config"])
                  ])
                ], 12, _hoisted_3))
              }), 128))
            ]),
            _: 1
          }, 8, ["list"]),
          _hoisted_7
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_ctx.rowLayout)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_el_table, {
                  size: "default",
                  "header-cell-style": {
                        background: '#f5f7fa',
                        padding: '3px 0',
                    },
                  border: _ctx.showBorder,
                  data: _ctx._value,
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      fixed: "",
                      type: "index",
                      label: "序号",
                      width: "50"
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._columns, (column, index) => {
                      return (_openBlock(), _createBlock(_component_el_table_column, {
                        "min-width": _ctx.getMinWidth(column),
                        prop: column.id,
                        label: column.title
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_FormDesignRender, {
                            modelValue: _ctx._value[scope.$index][column.id],
                            "onUpdate:modelValue": ($event: any) => ((_ctx._value[scope.$index][column.id]) = $event),
                            class: _normalizeClass({
                                    'valid-error': _ctx.showError(column, _ctx._value[scope.$index][column.id]),
                                }),
                            mode: _ctx.mode,
                            config: column
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "mode", "config"])
                        ]),
                        _: 2
                      }, 1032, ["min-width", "prop", "label"]))
                    }), 256)),
                    _createVNode(_component_el_table_column, {
                      fixed: "right",
                      "min-width": "90",
                      label: "操作"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          size: "default",
                          type: "text",
                          onClick: ($event: any) => (_ctx.copyData(scope.$index, scope.row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_button, {
                          size: "default",
                          type: "text",
                          onClick: ($event: any) => (_ctx.delRow(scope.$index, scope.row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["border", "data"]),
                _createVNode(_component_el_button, {
                  size: "default",
                  icon: "Plus",
                  onClick: _ctx.addRow
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.placeholder), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._value, (row, i) => {
                  return (_openBlock(), _createBlock(_component_el_form, {
                    ref_for: true,
                    ref: `table-form-${i}`,
                    key: i,
                    rules: _ctx.rules,
                    model: row,
                    class: "table-column"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", null, "第 " + _toDisplayString(i + 1) + " 项", 1),
                        _createVNode(_component_el_icon, {
                          onClick: ($event: any) => (_ctx.delRow(i, row))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Close)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._columns, (column, index) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 'column_' + index,
                          prop: column.id,
                          label: column.title
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_FormDesignRender, {
                              modelValue: row[column.id],
                              "onUpdate:modelValue": ($event: any) => ((row[column.id]) = $event),
                              mode: _ctx.mode,
                              config: column
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "mode", "config"])
                          ]),
                          _: 2
                        }, 1032, ["prop", "label"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["rules", "model"]))
                }), 128)),
                _createVNode(_component_el_button, {
                  size: "default",
                  icon: "Plus",
                  onClick: _ctx.addRow
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.placeholder), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
        ]))
  ]))
}